import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './card-update.html';

@Component({
    controllerAs: 'cardUpdate',
    template
})

export default class cardUpdate {
    static $inject = [
        '$scope',
        '$ngRedux',
        '$state',
        'toaster',
        '$stateParams',
        'spinnerService',
        'orderService',
        'authService',
        '$window', 'APP',
        'Heartland',
        'GlobalPayments',
        '$uibModal'
    ];

    constructor($scope, $ngRedux, $state, $toaster, $stateParams, $spinner, $order, $auth, $window, APP, Heartland, GlobalPayments,$uibModal) {
        const disconnect = $ngRedux.connect(this.mapState)(this);
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$order = $order;
        this.$toaster = $toaster;
        this.$uibModal = $uibModal;
        this.logoIcon = logoIcon;
        this.houseIcon = houseIcon;
        this.$window = $window;
        this.$auth = $auth;
        this.APP = APP;
        this.$spinner = $spinner;
        this.giftCardNumbers = [];
        this.totalGiftAmount = 0.00;
        this.hasErplyCardUpdateInitialized = false;
        this.heartand_Approval = "APPROVAL";
        this.count = 0;
        $spinner.show('appSpinner');
        if(window.innerWidth < 768) {
            // console.log('mobileView');
            this.mobileView = true;
        } else {
            this.mobileView = false;
        }
        $order.getPaymentKeys().then(success => {

            this.paymentGlobalKey = success.data.globalKey;
            this.updateCardId = this.$stateParams.cardId;
            this.paymentType = success.data.paymentType;
            this.version = success.data.version;
            this.uuid = success.data.uuid;
            this.gatewayUrl = success.data.url;
            if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.heartLand) {
                setTimeout(() => {
                this.initializeHeartland(Heartland);
            }, 100);
            } else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.tsys) {
                setTimeout(() => {
                    // this.paymentGlobalKey = success.data.globalKey;
                    this.env = success.data.enviroment;
                    this.initializeTsys(GlobalPayments);
                }, 100);
                // this.initializeTsys(GlobalPayments);
            } else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.moneris) {
                setTimeout(() => {
                    // this.paymentGlobalKey = success.data.globalKey;
                    this.env = success.data.enviroment;
                    if(window.innerWidth < 768) {
                        // console.log('inside mobile');
                        document.getElementById("monerisFrameUpdate").src = this.gatewayUrl+"?id=" + this.paymentGlobalKey +
                        "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&display_labels=1&enable_exp=1&enable_cvd=1" +
            
                        "&css_textbox=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
                        "padding: 6px 12px;line-height: 1.42;"+
                        "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px"+

                        "&css_label_pan=;margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif"+
                        "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif"+
                        "&css_label_cvd=;margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif";
                    } else {
                        document.getElementById("monerisFrameUpdate").src = this.gatewayUrl+"?id=" + this.paymentGlobalKey +
                        "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;&display_labels=1&enable_exp=1&enable_cvd=1" +
            
                        "&css_textbox=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
                        "padding: 6px 12px;line-height: 1.42;"+
                        "margin-top: 5px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px"+
    
                        "&css_label_pan=;margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif"+
                        "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif"+
                        "&css_label_cvd=;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif";
                    }
                    
                    this.initializeMoneris();
                }, 100);
            }
        })
            .finally(() => $spinner.hide('appSpinner'));
        if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.heartLand) {
            this.$onDestroy = function () {
                this.hps.dispose();
            };
        }
    }

    initializeHeartland(Heartland) {
        var $ctrl = this;
        // console.log("Updating card id : ", this.updateCardId, " ", $ctrl.paymentGlobalKey);
        this.hps = new Heartland.HPS({
            publicKey: $ctrl.paymentGlobalKey,
            type: 'iframe',
            // Configure the iframe fields to tell the library where
            // the iframe should be inserted into the DOM and some
            // basic options
            fields: {
                cardNumber: {
                    target: 'iframesCardNumber',
                    placeholder: 'xxxx xxxx xxxx xxxx'
                },
                cardExpiration: {
                    target: 'iframesCardExpiration',
                    placeholder: 'MM / YYYY'
                },
                cardCvv: {
                    target: 'iframesCardCvv',
                    placeholder: 'CVV'
                },
                submit: {
                    value: 'submit',
                    target: 'iframesSubmit'
                }
            },
            // Collection of CSS to inject into the iframes.
            // These properties can match the site's styles
            // to create a seamless experience.
            style: {
                'input': {
                    'background': '#fff',
                    'border': '1px solid',
                    'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
                    'box-sizing': 'border-box',
                    'font-family': 'serif',
                    'font-size': '16px',
                    'line-height': '1',
                    'margin': '0 .5em 0 0',
                    'max-width': '100%',
                    'outline': '0',
                    'padding': '0.5278em',
                    'vertical-align': 'baseline',
                    'height': '50px',
                    'width': '100% !important'
                },
                '#heartland-field': {
                    'font-family': 'sans-serif',
                    'box-sizing': 'border-box',
                    'display': 'block',
                    'height': '50px',
                    'padding': '6px 12px',
                    'font-size': '14px',
                    'line-height': '1.42857143',
                    'color': '#555',
                    'background-color': '#fff',
                    'border': '1px solid #ccc',
                    'border-radius': '0px',
                    '-webkit-box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
                    'box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
                    '-webkit-transition': 'border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s',
                    '-o-transition': 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
                    'transition': 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
                    'width': '100%'
                },
                '#heartland-field[name=submit]': {
                    'background-color': '#a4182d',
                    'font-family': 'sans-serif',
                    'text-transform': 'uppercase',
                    'color': '#ffffff',
                    'border': '0px solid transparent',
                    'width': '200px !important',
                    'margin-left': '5px  !important'
                },
                '#heartland-field[name=submit]:focus': {
                    'color': '#ffffff',
                    'background-color': '#a4182d',
                    'outline': 'none'
                },
                '#heartland-field[name=submit]:hover': {
                    'background-color': ' #a4182d'
                },
                '#heartland-field-wrapper #heartland-field:focus': {
                    'border': '1px solid #3989e3',
                    'outline': 'none',
                    'box-shadow': 'none',
                    'height': '50px'
                },
                'heartland-field-wrapper #heartland-field': {
                    'height': '50px'
                },
                'input[type=submit]': {
                    'box-sizing': 'border-box',
                    'display': 'inline-block',
                    'padding': '6px 12px',
                    'margin-bottom': '0',
                    'font-size': '14px',
                    'font-weight': '400',
                    'line-height': '1.42857143',
                    'text-align': 'center',
                    'white-space': 'nowrap',
                    'vertical-align': 'middle',
                    '-ms-touch-action': 'manipulation',
                    'touch-action': 'manipulation',
                    'cursor': 'pointer',
                    '-webkit-user-select': 'none',
                    '-moz-user-select': 'none',
                    '-ms-user-select': 'none',
                    'user-select': 'none',
                    'background-image': 'none',
                    'border': '1px solid transparent',
                    'border-radius': '4px',
                    'color': '#fff',
                    'background-color': '#a4182d',
                    'border-color': '#2e6da4'
                },
                '#heartland-field[placeholder]': {
                    'letter-spacing': '3px'
                },
                '#heartland-field[name=cardCvv]': {
                    'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/cvv1.png?raw=true) no-repeat right',
                    'background-size': '63px 40px'
                },
                'input#heartland-field[name=cardNumber]': {
                    'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-inputcard-blank@2x.png?raw=true) no-repeat right',
                    'background-size': '55px 35px'
                },
                '#heartland-field.invalid.card-type-visa': {
                    'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right',
                    'background-size': '83px 88px',
                    'background-position-y': '-44px'
                },
                '#heartland-field.valid.card-type-visa': {
                    'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right top',
                    'background-size': '82px 86px'
                },
                '#heartland-field.invalid.card-type-discover': {
                    'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
                    'background-size': '85px 90px',
                    'background-position-y': '-44px'
                },
                '#heartland-field.valid.card-type-discover': {
                    'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
                    'background-size': '85px 90px',
                    'background-position-y': '1px'
                },
                '#heartland-field.invalid.card-type-amex': {
                    'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right',
                    'background-size': '50px 90px',
                    'background-position-y': '-44px'
                },
                '#heartland-field.valid.card-type-amex': {
                    'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right top',
                    'background-size': '50px 90px'
                },
                '#heartland-field.invalid.card-type-mastercard': {
                    'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
                    'background-size': '62px 105px',
                    'background-position-y': '-52px'
                },
                '#heartland-field.valid.card-type-mastercard': {
                    'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
                    'background-size': '62px 105px',
                    'background-position-y': '-1px'
                },
                '#heartland-field.invalid.card-type-jcb': {
                    'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right',
                    'background-size': '55px 94px',
                    'background-position-y': '-44px'
                },
                '#heartland-field.valid.card-type-jcb': {
                    'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right top',
                    'background-size': '55px 94px',
                    'background-position-y': '2px'
                },
                'input#heartland-field[name=cardNumber]::-ms-clear': {
                    'display': 'none'
                }
            },
            // Callback when a token is received from the service
            onTokenSuccess: function (resp) {
                // console.log('Received Token from Heartland : ', resp.token_value);
                $ctrl.$spinner.show('appSpinner');
                let dataReq = {
                    "token": resp.token_value,
                    // "isNewCard": true,
                    "cardLast4": resp.last_four,
                    "cardType": resp.card_type,
                    "cardNumber": resp.card.number,
                    "expiryMonth": resp.exp_month,
                    "expiryYear": resp.exp_year,
                    "cardId": $ctrl.updateCardId
                };
                if (!$ctrl.hasErplyCardUpdateInitialized) {
                    $ctrl.hasErplyCardUpdateInitialized = true;
                    $ctrl.$order.updateCardHeartland(dataReq)
                        .then(success => {
                            $ctrl.hasErplyCardUpdateInitialized = false;
                            $ctrl.clearIframeFields();
                            $ctrl.showHeartLandPage = false;
                            $ctrl.$spinner.hide('appSpinner');

                            if(success.data.successCode=="429") {
                                this.showMessageInPopUp(success.data.message);
                            } else {
                                if (success.data.successCode === '00') {
                                    $ctrl.$toaster.pop('success', 'Card Updated Successfully');
                                    //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
                                    $ctrl.$state.go('cards-management', { 'success': 'success' });
    
                                }
                                else {
                                    //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
                                    $ctrl.$state.go('cards-management', { 'success': 'Failure' });
                                    $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
                                    $ctrl.isCallingAPI = false;
                                }
                            }                           
                        },
                            error => {
                                $ctrl.hasErplyCardUpdateInitialized = false;
                                $ctrl.clearIframeFields();
                                $ctrl.$spinner.hide('appSpinner');
                                $ctrl.showHeartLandPage = false;
                                $ctrl.isCallingAPI = false;
                                $ctrl.$state.go('cards-management', { 'success': 'Failure' });
                                //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
                                $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
                                // var myEl = angular.element( document.querySelector( '#credit-card' ) );
                                // myEl.remove();
                            }
                        )
                        .catch(err => {
                            $ctrl.hasErplyCardUpdateInitialized = false;
                            $ctrl.clearIframeFields();
                            $ctrl.$spinner.hide('appSpinner');
                            $ctrl.showHeartLandPage = false;
                            $ctrl.isCallingAPI = false;
                            // $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
                            $ctrl.$state.go('cards-management', { 'success': 'Failure' });
                            $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
                        });
                }
            },
            // Callback when an error is received from the service
            onTokenError: function (resp) {
                $ctrl.hasErplyCardUpdateInitialized = false;
                $ctrl.clearIframeFields();
                $ctrl.$spinner.hide('appSpinner');
                // console.log("Error - ", resp);
                $ctrl.showHeartLandPage = false;
                $ctrl.isCallingAPI = false;
                // $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
                $ctrl.$state.go('cards-management', { 'success': 'Failure' });
                $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
            },
            // Callback when an event is fired within an iFrame
            onEvent: function (ev) {
                // // console.log(ev);
            }
        });

        this.$onDestroy = function () {
            this.hps.dispose();
        };
    }


    initializeTsys(GlobalPayments) {
        var $ctrl = this;
        GlobalPayments.configure({
            'X-GP-Api-Key': this.paymentGlobalKey,
            'X-GP-Environment': this.env,
            'enableAutocomplete': true
        });


        var cardForm = GlobalPayments.ui.form({
            type: 'iframe',
            fields: {
                "card-number": {
                    target: "#card-number",
                    placeholder: "xxxx xxxx xxxx xxxx"
                },
                "card-expiration": {
                    target: "#card-expiration",
                    placeholder: "MM / YYYY"
                },
                "card-cvv": {
                    target: "#card-cvv",
                    placeholder: "xxx"
                },
                "submit": {
                    target: "#submit",
                    text: "Submit"
                }
            },

            styles: {

                "input": {
                    "outline": "none",
                    "border-width": "0",
                    "letter-spacing": "2px",
                    "width": "20px",
                    "height": "40px"
                },
                "input, select": {
                    "padding": "5px 10px",
                    "font-size": "13px",
                    "background": "#f3faff",
                    "border": "1px solid #e0f1ff",
                    "box-sizing": "border-box",
                    "width": "20px",
                    "height": "40px"
                },
                "input:focus": {
                    "-webkit-box-shadow": "inset 0px 0px 3px 0px #b0dcff !important",
                    "box-shadow": "inset 0px 0px 3px 0px #b0dcff !important",
                    "border-color": "#b0dcff !important",
                    "width": "20px",
                    "height": "40px"
                },
                "button": {
                    "pointer-events": "none",
                    "opacity": ".5",


                    'box-sizing': 'border-box',
                    'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
                    'font-size': '15px',
                    'line-height': '1',
                    'width': 'auto !important',
                    'outline': '0',
                    'padding': '.5278em',
                    'vertical-align': 'baseline',
                    'height': '50px',
                    'background-color': '#a4182d',
                    'font-family': 'sans-serif',
                    'text-transform': 'uppercase',
                    'border': '0 solid transparent',
                    'color': '#fff',
                    // 'cursor': 'pointer',
                    'flex': '0.61 1 auto !important'
                },
                "button:active": {
                    "filter": "brightness(112%)",
                    "text-align": "center"
                },
                ".card-number.card-type-visa": {
                    "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-visa@2x.png) no-repeat right",
                    "background-position-y": "0px",
                    "background-size": "70px 75px",
                    "width": "50px"
                },
                ".card-number.card-type-mastercard": {
                    "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-mastercard@2x.png) no-repeat right",
                    "background-position-y": "4px",
                    "background-size": "60px 64px"
                },
                ".card-number.card-type-discover": {
                    "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-discover@2x.png) no-repeat right",
                    "background-position-y": "-5px",
                    "background-size": "90px 96px"
                },
                ".card-number.card-type-jcb": {
                    "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-jcb@2x.png) no-repeat right",
                    "background-position-y": "0px",
                    "background-size": "48px 82px"
                },
                ".card-number.card-type-amex": {
                    "background": "#f3faff url(https://hps.github.io/token/gp-1.0.0/images/logo-amex@2x.png) no-repeat right",
                    "background-position-y": "-4px",
                    "background-size": "55px 98px"
                }
            }
        });


        cardForm.on("token-success", resp => {
            // add a payment token to form as a hidden input
            // console.log("token-success", resp);
            const token = document.createElement("input");
            token.type = "hidden";
            token.name = "temporary_token";
            token.value = "resp.temporary_token";

            // submit temporary_token to backend, process with our gateway
            // const form = document.getElementById("payment-form");
            // form.appendChild(child);
            // form.submit;



            // console.log("Token Success", resp.temporary_token);
            $ctrl.$spinner.show('appSpinner');
            let dataReq = {
                "token": resp.temporary_token,
                // "isNewCard": true,
                "cardLast4": resp.last_four,
                "cardType": resp.card_type,
                "cardNumber": resp.card.number,
                "expiryMonth": resp.exp_month,
                "expiryYear": resp.exp_year,
                "cardId": $ctrl.updateCardId
            };

            if (!$ctrl.hasErplyCardUpdateInitialized) {
                $ctrl.hasErplyCardUpdateInitialized = true;
                $ctrl.$order.updateCardTsys(dataReq)
                    .then(success => {
                        $ctrl.hasErplyCardUpdateInitialized = false;
                        $ctrl.$spinner.hide('appSpinner');
                        $ctrl.showHeartLandPage = false;
                        if(success.data.successCode=="429") {
                            this.showMessageInPopUp(success.data.message);
                        } else {
                            if (success.data.successCode === '00') {
                                $ctrl.$toaster.pop('success', 'Card Updated Successfully');
                                //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
                                $ctrl.$state.go('cards-management', { 'success': 'success' });
    
                            }
                            else {
                                //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
                                $ctrl.$state.go('cards-management', { 'success': 'Failure' });
                                $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
                                $ctrl.isCallingAPI = false;
                            }
                        }
                    },
                        error => {
                            $ctrl.hasErplyCardUpdateInitialized = false;
                            $ctrl.clearIframeFields();
                            $ctrl.$spinner.hide('appSpinner');
                            $ctrl.showHeartLandPage = false;
                            $ctrl.isCallingAPI = false;
                            $ctrl.$state.go('cards-management', { 'success': 'Failure' });
                            //   $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
                            $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
                            // var myEl = angular.element( document.querySelector( '#credit-card' ) );
                            // myEl.remove();
                        }
                    )
                    .catch(err => {
                        $ctrl.hasErplyCardUpdateInitialized = false;
                        $ctrl.clearIframeFields();
                        $ctrl.$spinner.hide('appSpinner');
                        $ctrl.showHeartLandPage = false;
                        $ctrl.isCallingAPI = false;
                        // $ctrl.$order.getPaymentInfo().then(success => $ctrl.cardId = success.data[0].id);
                        $ctrl.$state.go('cards-management', { 'success': 'Failure' });
                        $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
                    }
                    );
            }
        });

        cardForm.on("token-error", resp => {
            // console.log("token-error", resp);
            $ctrl.cardFailure();
        });

        GlobalPayments.on("error", error => {
            // console.log("error", error);
            $ctrl.cardFailure();
        });

        cardForm.on("card-number-test", function (resp) {
            $ctrl.cardvalid = resp.valid;
            $ctrl.submitButtonState(cardForm);
            // console.log("card-number-test", resp);
        });

        cardForm.on("card-expiration-test", resp => {
            //   // console.log("card-expiration-test", resp);
            $ctrl.expdatevalid = resp.valid;
            $ctrl.submitButtonState(cardForm);
            // console.log("card-expiration-test", resp);
        });

        cardForm.on("card-cvv-test", resp => {
            $ctrl.cvvalid = resp.valid;
            $ctrl.submitButtonState(cardForm);
            // console.log("card-cvv-test", resp);
        });

    }

    clearIframeFields() {
        var heartlandcontenthtml = angular.element(document.querySelector('#heartlandcontent'));
        var iframesG = angular.element(document.querySelector('#iframes'));
        var cardNumberIframe = angular.element(document.querySelector('#iframesCardNumber'));
        var CardExpIframe = angular.element(document.querySelector('#iframesCardExpiration'));
        var CardCvvIframe = angular.element(document.querySelector('#iframesCardCvv'));
        var CardSubmitIframe = angular.element(document.querySelector('#iframesSubmit'));
    }

    cardFailure() {
        var $ctrl = this;
        $ctrl.hasErplyCardUpdateInitialized = false;
        $ctrl.clearIframeFields();
        $ctrl.$spinner.hide('appSpinner');
        $ctrl.showHeartLandPage = false;
        $ctrl.isCallingAPI = false;
        $ctrl.$state.go('cards-management', { 'success': 'Failure' });
        $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
    }
    goBack() {
        this.$state.go('cards-management');
    }

    submitButtonState(cardForm) {
        var $ctrl = this;
        // console.log("cardForm := ",cardForm);
        // console.log($ctrl.cardvalid + ", " + $ctrl.expdatevalid + ", " + $ctrl.cvvalid);
        if (($ctrl.cvvalid && $ctrl.cardvalid && $ctrl.expdatevalid)) {
            cardForm.addStylesheet({
                "button": {
                    "pointer-events": "auto",
                    "opacity": "1",

                    'box-sizing': 'border-box',
                    'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
                    'font-size': '15px',
                    'line-height': '1',
                    'width': 'auto !important',
                    'outline': '0',
                    'padding': '.5278em',
                    'vertical-align': 'baseline',
                    'height': '50px',
                    'background-color': '#a4182d',
                    'font-family': 'sans-serif',
                    'text-transform': 'uppercase',
                    'border': '0 solid transparent',
                    'color': '#fff',
                    'cursor': 'pointer',
                    'flex': '0.61 1 auto !important'
                }
            });
        } else {
            cardForm.addStylesheet({
                "button": {
                    "pointer-events": "none",
                    "opacity": ".5",


                    'box-sizing': 'border-box',
                    'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
                    'font-size': '15px',
                    'line-height': '1',
                    'width': 'auto !important',
                    'outline': '0',
                    'padding': '.5278em',
                    'vertical-align': 'baseline',
                    'height': '50px',
                    'background-color': '#a4182d',
                    'font-family': 'sans-serif',
                    'text-transform': 'uppercase',
                    'border': '0 solid transparent',
                    'color': '#fff',
                    // 'cursor': 'pointer',
                    'flex': '0.61 1 auto !important'
                }
            });
        }
    }


    // Moneris
    initializeMoneris() {
        var $ctrl = this;
       
        $ctrl.respUpdateMsg = function (e) {
            // console.log("RespUpdateMsg get called ", e );
             // var respData = eval("(" + e.data + ")");
             // var resCode = `${respData.responseCode}`;
             // var resDataKey = `${respData.dataKey}`;
      
             var parsingJson = JSON.parse(e.data);
      
            // console.log("Parsing Json : ",parsingJson);
            // console.log("dataKey : ",parsingJson.dataKey);
            // console.log("responseCode : ",parsingJson.responseCode);
            
            var resCode = parsingJson.responseCode;
            var resDataKey = parsingJson.dataKey;
      
            if (resCode != null) {
            //   resCode = resCode.split(',');
              // console.log("ResCode : ", resCode, " : ResCode length: ", resCode.length);
              if (resCode.length > 0) {
                if (resCode[0] == '001') {
                  $ctrl.cardUpdateMoneris(resDataKey);
                } else {
                    var srcLink = '';
                    if(window.innerWidth < 768) {
                        // console.log('inside mobile');
                          srcLink = $ctrl.gatewayUrl + "?id=" + $ctrl.paymentGlobalKey +
                            "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;;&display_labels=1&enable_exp=1&enable_cvd=1" +
                            
                            "&css_textbox=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
                            "padding: 6px 12px;line-height: 1.42;"+
                            "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px";

                            if (resCode[0] == 943) {
                                srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif"+
                                "&css_textbox_pan=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
                                "padding: 6px 12px;line-height: 1.42;"+
                                "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px" +
                                "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif"+
                                "&css_label_cvd=;margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif";
                
                            } else if (resCode[0] == 944) {
                                srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif"+
                                "&css_label_exp=margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif"+
                                "&css_label_cvd=margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" +
                                "&css_textbox_exp=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
                                "padding: 6px 12px;line-height: 1.42;"+
                                "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px";
                                
                            } else if (resCode[0] == 945) {
                                srcLink = srcLink + "&css_label_pan=margin-left: 10px;margin-right:28px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif"+
                                "&css_label_exp=;margin-left: 10px;margin-right:40px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif"+
                                "&css_label_cvd=margin-left: 10px;margin-right:91px;font-weight: 700;font-size: 15px;color: darkslategrey;font-family: sans-serif" +
                                "&css_textbox_cvd=width:329px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
                                "padding: 6px 12px;line-height: 1.42;"+
                                "margin-top: 10px;margin-left: 10px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px";
                            }else {
                                console.log("Moneris page not loaded due to : ",resCode[0], " check for https://developer.moneris.com/More/Testing/Response%20Codes");
                                $ctrl.goBack();
                            }
                    } else {
                        srcLink = $ctrl.gatewayUrl + "?id=" + $ctrl.paymentGlobalKey +
                            "&pmmsg=true&css_body=background:none;&css_textbox=border-width:2px;;&display_labels=1&enable_exp=1&enable_cvd=1" +
                            // "&css_textbox_pan=width:250px;height: 35px;margin-bottom: 10px;margin-top: 5px" +
                            // "&css_textbox_exp=width:250px;height: 35px;margin-bottom: 10px;margin-top: 5px" +
                            // "&css_textbox_cvd=width:250px;height: 35px;margin-bottom: 10px;margin-top: 5px;" +
                            // "&css_input_label=";
                            "&css_textbox=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
                            "padding: 6px 12px;line-height: 1.42;"+
                            "margin-top: 5px;margin-right: 10px;border: 1.5px solid gainsboro;border-radius: 0px";
                        if (resCode[0] == 943) {
                            srcLink = srcLink + "&css_label_pan=color:darkslategrey;margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif"+
                            "&css_textbox_pan=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
                            "padding: 6px 12px;line-height: 1.42;"+
                            "margin-top: 5px;margin-right: 10px;border: 1.5px solid red;border-radius: 0px" +
                            "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif"+
                            "&css_label_cvd=;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif";
            
                        } else if (resCode[0] == 944) {
                            srcLink = srcLink + "&css_label_pan=margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif"+
                            "&css_label_exp=color:darkslategrey;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif"+
                            "&css_label_cvd=margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif" +
                            "&css_textbox_exp=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
                            "padding: 6px 12px;line-height: 1.42;"+
                            "margin-top: 5px;margin-right: 10px;border: 1.5px solid red !important;border-radius: 0px";
                            
                        } else if (resCode[0] == 945) {
                            srcLink = srcLink + "&css_label_pan=margin-right:28px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif"+
                            "&css_label_exp=;margin-right:40px;font-weight: 700;font-size: 15px;line-height: 2px;color: darkslategrey;font-family: sans-serif"+
                            "&css_label_cvd=color:darkslategrey;margin-right:91px;font-weight: 700;font-size: 15px;line-height: 2px;font-family: sans-serif" +
                            "&css_textbox_cvd=display:inline !important;width:330px;height: 50px;box-sizing: border-box;margin-bottom: 10px;"+
                            "padding: 6px 12px;line-height: 1.42;"+
                            "margin-top: 5px;margin-right: 10px;border: 1.5px solid red !important;border-radius: 0px";
                        }else {
                            console.log("Moneris page not loaded due to : ",resCode[0], " check for https://developer.moneris.com/More/Testing/Response%20Codes");
                            $ctrl.goBack();
                        }
                    }
                  document.getElementById("monerisFrameUpdate").src = srcLink;
                }
              }
            }
          };
      
      
          if (!this.APP.ORDER.MONERIS_LOADED.update_page_loaded) {
            this.APP.ORDER.MONERIS_LOADED.update_page_loaded = true;
            // console.log("Adding once this.respUpdateMsg : ", this.respUpdateMsg);
            if (window.addEventListener) {
              window.addEventListener("message", this.respUpdateMsg, false);
            }
            else {
              if (window.attachEvent) {
                window.attachEvent("onmessage", this.respUpdateMsg);
              }
            }
          }
    }

    doMonerisSubmit() {
        this.$spinner.show('appSpinner');
        var monFrameRef = document.getElementById('monerisFrameUpdate').contentWindow;
        // console.log("monFrameRef : ", monFrameRef);
        monFrameRef.postMessage('tokenize', this.gatewayUrl);
        this.$spinner.hide('appSpinner');
        return false;
    }

    cardUpdateMoneris(token) {
        var $ctrl = this;
        if (!this.hasPaymentInitialized) {
            this.hasPaymentInitialized = true;
            $ctrl.$spinner.show('appSpinner');
            // console.log("Updating moneris card");

            let dataReq = {
                "token": token,
                "action": "update",
                // "isNewCard": true,
                // "cardLast4": resp.last_four,
                // "cardType": resp.card_type,
                // "cardNumber": resp.card.number,
                // "expiryMonth": resp.exp_month,
                // "expiryYear": resp.exp_year,
                "cardId": $ctrl.updateCardId
            };


            $ctrl.$order.updateCardMoneris(dataReq)
                .then(success => {
                    $ctrl.hasPaymentInitialized = false;
                    $ctrl.$spinner.hide('appSpinner');
                    $ctrl.showHeartLandPage = false;
                    $ctrl.hasErplyCardUpdateInitialized = false;

                    if(success.data.successCode=="429") {
                        this.showMessageInPopUp(success.data.message);
                    } else {
                        if (success.data.successCode === '00') {
                            $ctrl.$toaster.pop('success', 'Card Updated Successfully');
                            $ctrl.$state.go('cards-management', { 'success': 'success' });
    
                        }
                        else { $ctrl.$state.go('cards-management', { 'success': 'Failure' });
                            $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
                            $ctrl.isCallingAPI = false;
                        }
                    }                    
                },
                    error => {
                        $ctrl.hasErplyCardUpdateInitialized = false;
                        $ctrl.clearIframeFields();
                        $ctrl.$spinner.hide('appSpinner');
                        $ctrl.showHeartLandPage = false;
                        $ctrl.isCallingAPI = false;
                        $ctrl.$state.go('cards-management', { 'success': 'Failure' });
                        $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
                    }
                )
                .catch(err => {
                    $ctrl.hasErplyCardUpdateInitialized = false;
                    $ctrl.clearIframeFields();
                    $ctrl.$spinner.hide('appSpinner');
                    $ctrl.showHeartLandPage = false;
                    $ctrl.isCallingAPI = false; 
                    $ctrl.$state.go('cards-management', { 'success': 'Failure' });
                    $ctrl.$toaster.pop('success', 'Unable to update your card currently. Please try again later.');
                });
        } else {
            // console.log(" Moneris Payment already iniitalized");
        }
    }


    
  showMessageInPopUp(message) {
    var $ctrl = this;
    this.$uibModal.open({
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      template: 
                    '<div class="modal-body" id="modal-body">' +
                    '<div class="container-fluid">' +
                    '<div class="col-md-12">{{message}}</div>' +
                      '<div class="modal-footer">' +
                      '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
                      '</div>' +
                    '</div>',
      controller: ['$scope', '$uibModalInstance',
        function ($scope, $uibModalInstance) {
          $scope.message = message;
          $scope.ok = () => {
            $uibModalInstance.close();
          };

        }
      ]
    });
  }

    $onDestroy = function () {
        // console.log('inside destroy');
        if(this.APP.ORDER.MONERIS_LOADED.update_page_loaded){
            if (window.addEventListener) {
                this.APP.ORDER.MONERIS_LOADED.update_page_loaded = false;
                window.removeEventListener("message", this.respUpdateMsg, false);
            } 
            else {
                if (window.attachEvent) {
                  window.attachEvent("onmessage", this.respUpdateMsg);
                }
              }
        }
    };

    
}



// WEBPACK FOOTER //
// ./src/app/order/cards-management/card-update.js